import { useState, useEffect } from "react";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import MDInput from "ui/MDInput";
import MDAlert from "ui/MDAlert";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import {
  Card,
  Grid,
  MenuItem,
  Select,
  Autocomplete,
  IconButton,
} from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { SaveButton } from "../common/buttons";
import fundsServices from "services/funds-services";
import { addFunds } from "../../redux/actions/fundActions";
import karkunService from "services/karkun-service";

const AddFunds = () => {
  const [karkuns, setKarkuns] = useState([]);
  const dispatch = useDispatch();
  const fundsOptions = ["Name-e-Mubarak", "Sadqa", "Khairat", "Nazar"];

  const [funds, setFunds] = useState({
    karkun: "",
    fundtype: "Name-e-Mubarak",
    amount: "",
  });

  const [errors, setErrors] = useState({
    karkunError: false,
    amountError: false,
    fundtypeError: false,
  });
  const [notification, setNotification] = useState(false);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    getKarkuns();
  }, []);

  const getKarkuns = async () => {
    try {

      const karkunData = await karkunService.getAll();
      if (karkunData.success && karkunData.karkuns) {
        setKarkuns(karkunData.karkuns);
      }
    } catch (error) {
      console.error("Error fetching karkuns:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => setNotification(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFunds({ ...funds, [name]: value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    setErrors({
      karkunError: false,
      amountError: false,
      fundtypeError: false,
    });

    if (!funds.karkun) return setErrors((p) => ({ ...p, karkunError: true }));
    if (!funds.amount) return setErrors((p) => ({ ...p, amountError: true }));
    if (!funds.fundtype)
      return setErrors((p) => ({ ...p, fundtypeError: true }));

    const fundsData = {
      karkun: funds.karkun,
      amount: funds.amount,
      fundtype: funds.fundtype,
    };

    setLoading(true);
    const response = await fundsServices.create(fundsData);
    setLoading(false);

    if (response.success) {
      dispatch(addFunds(fundsData));
      setNotification({ type: "success", message: response.message });
      setFunds({ karkun: "", fundtype: "", amount: "" });
    } else {
      setNotification({ type: "error", message: response.errors[0] });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Add Fund
                </MDTypography>
                <SaveButton loading={loading} onClick={submitHandler} />
              </MDBox>

              <MDBox
                component="form"
                role="form"
                onSubmit={submitHandler}
                display="flex"
                flexDirection="column"
                px={3}
              >
                {notification && (
                  <MDAlert color={notification.type} mt="20px">
                    <MDTypography variant="body2" color="white">
                      {notification.message}
                    </MDTypography>
                  </MDAlert>
                )}

                <MDBox display="flex" flexDirection="row" mt={5} mb={3}>

         
                  <MDBox width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1}>
                      Karkun
                    </MDTypography>

                    <Autocomplete
                      options={karkuns}   
                      getOptionLabel={(opt) =>
                        opt ? `${opt.karkunid} - ${opt.name}` : ""
                      }
                      onChange={(e, val) =>
                        setFunds({ ...funds, karkun: val ? val.id : "" })
                      }
                      renderInput={(params) => (
                        <MDInput
                          {...params}
                          error={errors.karkunError}
                          placeholder="Search & Select Karkun"
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "45px",
                            },
                          }}
                        />
                      )}
                    />

                    {errors.karkunError && (
                      <MDTypography variant="caption" color="error">
                        Please select a Karkun
                      </MDTypography>
                    )}
                  </MDBox>


                  {/* FUND TYPE FIELD */}
                  <MDBox width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1}>
                      Fund Type
                    </MDTypography>
                    <Select
                      fullWidth
                      name="fundtype"
                      value={funds.fundtype || "Name-e-Mubarak"}
                      onChange={changeHandler}
                      displayEmpty
                      error={errors.fundtypeError}
                      sx={{
                        height: "45px",
                        "& .MuiSelect-icon": { display: "none" },
                      }}
                      IconComponent={() => (
                        <IconButton
                        >
                          <ArrowDropDown />
                        </IconButton>
                      )}
                    >
                      {fundsOptions.map((fundtype) => (
                        <MenuItem key={fundtype} value={fundtype}>
                          {fundtype}
                        </MenuItem>
                      ))}
                    </Select>

                    {errors.fundtypeError && (
                      <MDTypography variant="caption" color="error">
                        Please provide Fund Type
                      </MDTypography>
                    )}
                  </MDBox>

                  {/* AMOUNT FIELD */}
                  <MDBox width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={6}>
                      Amount
                    </MDTypography>
                    <MDBox display="flex" alignItems="center">

                      <IconButton
                        onClick={() =>
                          setFunds({
                            ...funds,
                            amount: String(
                              Number(funds.amount || 0) - 50
                            ),
                          })
                        }
                        sx={{
                          background: "#e0e0e0",
                          borderRadius: "50%",
                          padding: "6px",
                        }}
                      >
                        <ArrowDropDown style={{ transform: "rotate(90deg)" }} />
                      </IconButton>

                      <MDInput
                        type="number"
                        name="amount"
                        value={funds.amount}
                        onChange={changeHandler}
                        fullWidth
                        sx={{
                          mx: 1,
                          "& .MuiInputBase-root": {
                            height: "45px",
                            textAlign: "center",
                          },
                        }}
                      />

                      <IconButton
                        onClick={() =>
                          setFunds({
                            ...funds,
                            amount: String(
                              Number(funds.amount || 0) + 50
                            ),
                          })
                        }
                        sx={{
                          background: "#e0e0e0",
                          borderRadius: "50%",
                          padding: "6px",
                        }}
                      >
                        <ArrowDropDown style={{ transform: "rotate(-90deg)" }} />
                      </IconButton>
                    </MDBox>

                    {errors.amountError && (
                      <MDTypography variant="caption" color="error">
                        Please provide amount
                      </MDTypography>
                    )}

                    <MDBox display="flex" justifyContent="center" gap={1} mt={2}>
                      {[200, 300, 500, 1000, 2000].map((v) => (
                        <MDBox
                          key={v}
                          onClick={() =>
                            setFunds({ ...funds, amount: String(v) })
                          }
                          sx={{
                            cursor: "pointer",
                            padding: "6px 10px",
                            borderRadius: "8px",
                            background: "#f0f0f0",
                            fontWeight: 600,
                          }}
                        >
                          {v}
                        </MDBox>
                      ))}
                    </MDBox>
                  </MDBox>

                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default AddFunds;